import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
    selector: 'mess_confirmabandon_dialog',
    templateUrl: 'mess_confirmabandon_dialog.component.html',
    styleUrls: ['mess_confirmabandon_dialog.component.scss']
})
export class MessConfirmAbandon implements OnInit {
    constructor(
        private router: Router,
        public dialogRef: MatDialogRef<MessConfirmAbandon>,
    ) {}

    ngOnInit() {}

    abandon(){
        this.router.navigateByUrl("/dossier");
        this.dialogRef.close({});
    }
    dismissDialog(){
        this.dialogRef.close({});
    }

}